import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=1c48e6fe&scoped=true&"
import script from "./VideoComponent.vue?vue&type=script&lang=ts&"
export * from "./VideoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c48e6fe",
  null
  
)

export default component.exports